import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.535 1.642a1 1 0 0 1 0 1.414l-4.95 4.95 4.95 4.95a1 1 0 0 1-1.414 1.414L4.464 8.713a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 0 1 1.414 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })